import PATHS from "../routes/paths";

// export const guestHeaderItems = [
//   { title: 'Home', path: PATHS.HOME },
//   { title: 'Web Cast', path: PATHS.WEB_CAST_SIGN_IN },
//   { title: 'Media', path: PATHS.VIDEO_TAB },
//   { title: 'What we believe', path: PATHS.WHAT_WE_BELIEVE },
//   // { title: 'Bible Seminars', path: PATHS.BIBLE_SEMINARS },
//   // { title: 'Resources', path: PATHS.QUICK_LINKS },
//   // { title: 'Contact Us', path: PATHS.CONTACT_US }
// ];

// export const superAdminHeaderItems = [
//   { title: 'Home', path: PATHS.HOME },
//   { title: 'Dashboard', path: PATHS.MANAGE_USERS },
//   { title: 'Web Cast', path: PATHS.WEB_CAST_SIGN_IN },
//   { title: 'Media', path: PATHS.VIDEO_TAB },
//   { title: 'What we believe', path: PATHS.WHAT_WE_BELIEVE },
//   // { title: 'Manage Users', path: PATHS.MANAGE_USERS },
//   // { title: 'Settings', path: PATHS.SETTINGS },
//   // { title: 'Reports', path: PATHS.REPORTS }
// ];

// export const adminHeaderItems = [
//   { title: 'Home', path: PATHS.HOME },
//   // { title: 'Subscriptions', path: PATHS.SUBSCRIPTIONS },
//   { title: 'Dashboard', path: PATHS.MANAGE_USERS },
//   { title: 'Web Cast', path: PATHS.WEB_CAST_SIGN_IN },
//   { title: 'Media', path: PATHS.VIDEO_TAB },
//   { title: 'What we believe', path: PATHS.WHAT_WE_BELIEVE },
//   // { title: 'My Profile', path: PATHS.MY_PROFILE },
//   // { title: 'Orders', path: PATHS.ORDERS }
// ];

export const headerItems = [
    // {title: 'Home', path: PATHS.HOME },
    { title: 'Dashboard', path: PATHS.USERS_TAB },
    { title: 'Webcast', path: PATHS.WEB_CAST_SIGN_IN },
    { title: 'Media', path: PATHS.VIDEO_TAB },
    { title: 'What We Believe', path: PATHS.WHAT_WE_BELIEVE },
    { title: 'Resources', path: PATHS.RESOURCES },
    { title: 'Ecclesial Documents', path: PATHS.ECCLESIAL_DOCUMENT },
    { title: 'Syllabus', path: PATHS.SYLLABUS },
    { title: 'Bible Seminars', path: PATHS.BIBLE_SEMINARS },
    { title: 'Contact Us', path: PATHS.CONTACT_US },
    // { title: 'Profile', path: PATHS.PROFILE },

];